import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './StartPage.module.css';
import logo from '../../assets/img/Logo.png';
import frame1 from '../../assets/img/frame1.svg';
import frame2 from '../../assets/img/frame2.svg';
import frame3 from '../../assets/img/frame3.svg';
import frame4 from '../../assets/img/frame4.svg';

import shape1 from '../../assets/img/shape4.svg';
import shape2 from '../../assets/img/shape7.svg';
import shape3 from '../../assets/img/shape3.svg';
import shape4 from '../../assets/img/shape1.svg';

const StartPage: React.FC = () => {
    const [isContactVisible, setIsContactVisible] = useState(false);
    const navigate = useNavigate();

    const handleStartCreating = () => {
        navigate('/onboarding');
    };

    const handleShowContact = () => {
        setIsContactVisible(true);
    };

    const handleShowMain = () => {
        setIsContactVisible(false);
    };

    return (
        <div className={s.start_page}>
            <header className={s.header_container}>
                <div className={s.logo_text} onClick={handleShowMain}>
                    <img src={logo} className={s.logo_icon} alt="Logo" />
                    SimpleeCreate
                </div>
                <a className={s.contact} onClick={handleShowContact}>
                    Contact us
                </a>
            </header>
            {isContactVisible ? (
                <main className={s.main_content}>
                    <h1 className={s.main_title}>Start Creating Now, It’s That Simple!</h1>
                    <form className={s.contact_form}>
                        <p className={s.contact_header}>We’d Love to Hear From You!</p>
                        <p className={s.main_subtitle_contact}>Have questions, feedback, or want to learn more about our services? Our team is here to help! Whether you're looking for support, have a business inquiry, or just want to say hi, we’re always happy to connect.</p>
                        <label className={s.form_label}>
                            <p className={s.text_info}>   General inquiries: </p>

                            <input type="text"
                                   value={'info@aiohub.gg'}
                                   className={s.form_input} />
                        </label>
                        <label className={s.form_label}>
                            <p className={s.text_info}>  Investment inquiries:</p>

                            <input type="email" className={s.form_input} value={'invest@aiohub.gg'} />
                        </label>
                        <label className={s.form_label}>
                            <p className={s.text_info}>   Partnerships & Affiliate Marketing:</p>

                            <input className={s.form_input} value={'partner@aiohub.gg'}/>
                        </label>

                    </form>
                </main>
            ) : (
                <main className={s.main_content}>
                    <h1 className={s.main_title}>Start Creating Now, It’s That Simple!</h1>
                    <p className={s.main_subtitle}>
                        Your ultimate creative content generation platform that simplifies your creation workflow with ease and joy!
                    </p>
                    <button className={s.start_button} onClick={handleStartCreating}>
                        START CREATING NOW
                    </button>
                    <p className={s.trial_info}>
                        Start now for free—your first 14 days are on us!
                    </p>
                </main>
            )}
            <footer className={s.footer_container}>
                <div className={s.left_footer}>
                    <p className={s.footer_link}>Product of AIOHub Inc</p>
                    <a className={s.footer_link} href="https://discord.gg/ZhwMGyxQ" target="_blank"
                       rel="noopener noreferrer">
                        Our Community
                    </a>

                </div>

                <div className={s.right_footer}>
                    <p
                        className={s.footer_link}
                        onClick={() => navigate('/privacy-policy')}
                    >
                        Privacy Policy
                    </p>
                    <p
                        className={s.footer_link}
                        onClick={() => navigate('/terms-of-use')}
                    >
                        Terms of Use
                    </p>
                    <p
                        className={s.footer_link}
                        onClick={() => navigate('/eula')}
                    >
                        EULA
                    </p>
                </div>
            </footer>
            <div className={s.background}>
                <img src={frame1} className={s.frame1} alt="Frame 1"/>
                <img src={frame2} className={s.frame2} alt="Frame 2"/>
                <img src={frame3} className={s.frame3} alt="Frame 3"/>
                <img src={frame4} className={s.frame4} alt="Frame 4"/>
                <img src={shape1} className={s.shape1} alt="Shape 1"/>
                <img src={shape2} className={s.shape2} alt="Shape 2"/>
                <img src={shape3} className={s.shape3} alt="Shape 3" />
                <img src={shape4} className={s.shape4} alt="Shape 4" />
            </div>
        </div>
    );
};

export default StartPage;
